import { jsx as _jsx } from "react/jsx-runtime";
import { QUERY_KEYS } from "@/components/myPage/constants/queryKeys";
import { useSideCategoryMenuStore } from "@/components/SideSheets/store/useCategoryMenuStore";
import { REDIRECT_QUERY } from "@/hooks/useRedirect";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { CASH_INDEX_PAGE, HOME_PAGE, LIBRARIES_INDEX_PAGE, LOGIN_PAGE, MYPAGE_COUPONS, MYPAGE_DEVICE_INDEX_PAGE, MYPAGE_ORDERS_INDEX_PAGE, MYPAGE_PAGE, MYPAGE_PASSES, SHOP_CART_PAGE, SOLVOOK_WRITE_STUDIO } from "@/settings/constant";
import { IconV2 } from "@bookips/sds";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
const scrollToTop = ()=>{
    window.scrollTo(0, 0);
};
export const useAppBar = ()=>{
    const router = useRouter();
    const { pathname  } = router;
    const queryClient = useQueryClient();
    const { isLoggedIn  } = useAuthStore();
    const { closeSideMenu , isOpenMobileSideMenu , isOpenSideMenu , openSideMenu  } = useSideCategoryMenuStore();
    // 페이지 이동 후 스크롤을 맨 위로 이동 (메뉴가 열려있으면 닫기)
    const navigateWithScrollToTop = (path)=>{
        closeSideMenu();
        router.push(path).then(()=>{
            scrollToTop();
        });
    };
    // 인증이 필요한 페이지 이동 (비로그인 시 로그인 페이지로 이동)
    const navigateWithAuth = (path)=>{
        closeSideMenu();
        if (!isLoggedIn) {
            router.push(LOGIN_PAGE);
            return;
        }
        navigateWithScrollToTop(path);
    };
    // 마이페이지 관련 경로들
    const mypagePaths = [
        MYPAGE_PAGE,
        SOLVOOK_WRITE_STUDIO,
        CASH_INDEX_PAGE,
        MYPAGE_COUPONS,
        MYPAGE_PASSES,
        MYPAGE_DEVICE_INDEX_PAGE,
        MYPAGE_ORDERS_INDEX_PAGE
    ];
    // 현재 path가 마이페이지 관련 경로인지 확인
    const isMypagePath = mypagePaths.some((path)=>pathname.startsWith(path));
    // 현재 path가 카테고리 관련 경로인지 확인 (/categories는 포함, /categories/edition은 제외)
    const isCategoryPath = pathname === "/categories";
    // 현재 path에 따라 activeKey 결정
    const getActiveKey = ()=>{
        // 카테고리 메뉴가 열려있거나 카테고리 페이지면 category가 active
        if (isOpenSideMenu || isCategoryPath) return "category";
        // 마이페이지 관련 경로면 mypage 활성화
        if (isMypagePath) return "mypage";
        if (pathname === HOME_PAGE) return "home";
        if (pathname.startsWith(LIBRARIES_INDEX_PAGE)) return "library";
        if (pathname.startsWith(SHOP_CART_PAGE)) return "cart";
        return undefined;
    };
    const activeKey = getActiveKey();
    const items = [
        {
            key: "category",
            label: "카테고리",
            icon: /*#__PURE__*/ _jsx(IconV2.Category, {
                thick: activeKey === "category"
            }),
            onClick: ()=>{
                if (isOpenSideMenu) {
                    closeSideMenu();
                } else {
                    // 마이페이지 사이드시트가 열려있으면 먼저 닫기
                    if (isOpenMobileSideMenu) {
                        closeSideMenu();
                    }
                    openSideMenu();
                }
            }
        },
        {
            key: "library",
            label: "자료 보관함",
            icon: /*#__PURE__*/ _jsx(IconV2.OldLibrary, {
                thick: activeKey === "library"
            }),
            onClick: ()=>navigateWithAuth(LIBRARIES_INDEX_PAGE)
        },
        {
            key: "home",
            label: "홈",
            icon: /*#__PURE__*/ _jsx(IconV2.Home, {
                thick: activeKey === "home"
            }),
            onClick: ()=>navigateWithScrollToTop(HOME_PAGE)
        },
        {
            key: "cart",
            label: "장바구니",
            icon: /*#__PURE__*/ _jsx(IconV2.Cart, {
                thick: activeKey === "cart"
            }),
            onClick: ()=>navigateWithAuth(SHOP_CART_PAGE)
        },
        {
            key: "mypage",
            label: "마이 쏠북",
            icon: /*#__PURE__*/ _jsx(IconV2.User, {
                thick: activeKey === "mypage"
            }),
            onClick: ()=>{
                closeSideMenu();
                if (!isLoggedIn) {
                    // 비로그인: 로그인 후 마이쏠북홈으로 리다이렉트
                    router.push({
                        pathname: LOGIN_PAGE,
                        query: {
                            [REDIRECT_QUERY]: MYPAGE_PAGE
                        }
                    });
                    return;
                }
                // 이미 마이쏠북홈이면 데이터 리프레시
                if (pathname === MYPAGE_PAGE) {
                    queryClient.invalidateQueries({
                        queryKey: [
                            ...QUERY_KEYS.MY_SOLVOOK_HOME
                        ]
                    });
                    scrollToTop();
                    return;
                }
                router.push(MYPAGE_PAGE).then(()=>scrollToTop());
            }
        }
    ];
    return {
        items,
        activeKey
    };
};
